<template>
  <vx-card>
    <div class="vx-card__title mb-10">
      <h2 class="mb-4">Конструктор бота</h2>
      <p>Добавляйте и редактируйте пункты меню чат-бота. Перетаскивайте пункты и подпункты, чтобы поменять их последовательность.</p>
    </div>
    <div class="steps-container">
      <ScenarioStepsList
        :steps="steps"
        @add="addMenuItem"
        @edit="editMenuItem"
        @delete="deleteMenuItem"
        @change="changeOrder"
      />
      <vs-button @click="addMenuItem(null)">Добавить пункт меню</vs-button>
    </div>
    <ScenarioPopup
      v-if="editingMenuItemId"
      :key="editingMenuItemId"
      :company-slug="companySlug"
      :scenario-slug="scenarioSlug"
      :step-id="editingMenuItemId"
      @update="updateStep"
      @close="editingMenuItemId = ''"
    />
  </vx-card>
</template>

<script>
import ScenarioStepsList from './ScenarioStepsList'
import ScenarioSteps from '../../../api/http/models/ScenarioSteps'
import ScenarioPopup from './ScenarioPopup'

export default {
  props: {
    companySlug: {
      type: String,
      required: true
    },
    scenarioSlug: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showPopup: false,
      editingMenuItemId: null,
      steps: []
    }
  },
  components: {
    ScenarioStepsList,
    ScenarioPopup
  },
  async created () {
    const response = await ScenarioSteps.getAll(this.companySlug, this.scenarioSlug)
    if (response.data) {
      this.steps = await this.createSteps(response.data)
    }
  },
  methods: {
    createSteps (items, parent_id = null) {
      const nested = []
      items.forEach(item => {
        if (item.parent_id === parent_id) {
          const children = this.createSteps(items, item.id)
          item.children = children.length ? children.sort((a, b) => a.order - b.order) : []
          nested.push(item)
        }
      })
      nested.sort((a, b) => a.order - b.order)
      return nested
    },
    findStepById (steps, id) {
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].id === id) {
          return steps[i]
        }
        const found = this.findStepById(steps[i].children, id)
        if (found) return found
      }
    },
    removeStep (id, parent_id) {
      const nodes = parent_id ? this.findStepById(this.steps, parent_id).children : this.steps
      nodes.splice(nodes.findIndex(node => id === node.id), 1)
    },
    addStep (step) {
      step.children = []
      const node = step.parent_id ? this.findStepById(this.steps, step.parent_id).children : this.steps
      node.push(step)
    },
    updateStep (step) {
      const node = this.findStepById(this.steps, step.id)
      node.depth = step.depth
      node.order = step.order
      node.parent_id = step.parent_id
      node.step_code = step.step_code
      node.title = step.title
    },
    editMenuItem (id) {
      this.showPopup = true
      this.editingMenuItemId = id
    },
    async addMenuItem (id) {
      const response = await ScenarioSteps.addOne(this.companySlug, this.scenarioSlug, {
        title: null,
        parent_id: id || null
      })
      if (response.status === 'success' && response.data) {
        this.addStep(response.data)
        this.$vs.notify({
          color: 'success',
          title: 'Пункт меню успешно добавлен',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка, что-то пошло не так',
          text: ''
        })
      }
    },
    async deleteMenuItem (data) {
      const response = await ScenarioSteps.deleteOne(this.companySlug, this.scenarioSlug, data.id)
      if (response.status === 'success') {
        this.removeStep(data.id, data.parent_id)
        this.$vs.notify({
          color: 'success',
          title: 'Пункт меню успешно удален',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка, что-то пошло не так',
          text: ''
        })
      }
    },
    async changeOrder (data) {
      const parent_id = data.moved.element.parent_id || null
      const nodes = parent_id ? this.findStepById(this.steps, parent_id).children : this.steps
      const steps = nodes.map((node, index) => ({
        id: node.id,
        order: index + 1,
        step_code: node.step_code
      }))
      const response = await ScenarioSteps.sort(this.companySlug, this.scenarioSlug, {
        parent_id,
        steps
      })
      if (response.status === 'success' && response.data) {
        response.data.forEach(step => {
          this.updateStep(step)
        })
        this.$vs.notify({
          color: 'success',
          title: 'Элементы отсортированы',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка, что-то пошло не так',
          text: ''
        })
      }
    }
  }
}
</script>
